import React from "react";
import "./Navbar.css";
import navLogo from "../../assets/mp-nav-logo.svg";

import { Link } from "react-router-dom";

export default function Navbar() {
  const handleLaunchNow = () => {
    window.open(
      "https://www.bitcoinstable.money/",
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container">
        <a className="navbar-brand centered-link" href="/">
          <img src={navLogo} alt="" className="nav-bar-icon"></img>
          <span className="nav-header-first">Money </span>
          <span className="nav-header-second">Protocol</span>
        </a>
        <div className="flex-fill"></div>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a
                className="nav-link active"
                href="https://docs.moneyprotocol.co" // Replace with your actual GitHub URL
                target="_blank"
                rel="noopener noreferrer"
              >
                Docs
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://github.com/moneyprotocol" // Replace with your actual GitHub URL
                target="_blank"
                rel="noopener noreferrer"
              >
                Github
              </a>
            </li>
            <li className="nav-item">
              <Link to="/faq" className="nav-link">
                FAQ
              </Link>
            </li>
            <li className="nav-item">
              <button
                className="nav-button nav-button-custom"
                onClick={handleLaunchNow}
              >
                Launch Now
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
